@if (title(); as titleText) {
  <rt-heading class="title" variant="heading semi-bold">{{ titleText }}</rt-heading>
}

@if (rendered().length > 0) {
  <ul class="grid">
    @for (item of rendered(); track itemKey(item)) {
      <li>
        @switch (item.kind) {
          @case ('candidate') {
            <rt-list-item-candidate [data]="item.data" />
          }
          @case ('team-member') {
            <rt-list-item-team-member [data]="item.data" />
          }
          @case ('job') {
            <rt-list-item-job [data]="item.data" />
          }
          @case ('talent-pool') {
            <rt-list-item-talent-pool [data]="item.data" />
          }
          @case ('link') {
            <rt-list-item-link [data]="item.data" />
          }
          @case ('event') {
            <rt-list-item-event [data]="item.data" />
          }
          @case ('evaluation') {
            <rt-list-item-evaluation [data]="item.data" />
          }
          @case ('task') {
            <rt-list-item-task [data]="item.data" />
          }
          @case ('requisition') {
            <rt-list-item-requisition [data]="item.data" />
          }
        }
      </li>
    }
  </ul>

  @if (overflow() > 0) {
    <button class="show-more" type="button" (click)="toggleExpanded()">
      {{
        expanded()
          ? ('app.common.show_less' | translate)
          : ('app.common.show_more_count' | translate: { count: overflow() })
      }}
    </button>
  }
}
